var info = {
  'es-es': {
    'index': {
      'html':
      '<div class="white--text">' +
      '<h2 class="display-3">Rethinking Medical Exchange</h2>' +
      '<p class="headline">Idonia es un servicio en la nube que garantiza <strong>seguridad en el acceso, comunicación y portabilidad </strong> de los registros médicos y las imágenes, entre los profesionales médicos y el paciente.</p>' +
      '<p>' +
      '<a target="_blank" href="https://twitter.com/IdoniaHealth"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg></a>' +
      '<a target="_blank" href="https://www.facebook.com/IdoniaHealth-307636029699684/"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="white" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg></a>' +
      '<a target="_blank" href="http://www.linkedin.com/company/idonia"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="white" d="M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z"/></svg></a>' +
      '</p>' +
      '</div>',
      'color': '#44A9D5',
      'meta': {title: 'Idonia',
        meta: [
          {'charset': 'utf-8'}
        ]
      }
    },
    'info': [
      {
        'path': 'caracteristicas',
        'path_id': 'features',
        'html': '/static/info/es/features.html',
        'title': 'Características',
        'header': true,
        'meta': {title: 'Características',
          meta: [
          {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'soluciones',
        'path_id': 'solutions',
        'html': '/static/info/es/solutions.html',
        'title': 'Soluciones',
        'header': true,
        'meta': {title: 'Soluciones',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      // {
      //   'path': 'icd',
      //   'html': 'https://icd.idonia.com',
      //   'title': '¡Calcule su ahorro!',
      //   'header': true,
      //   'meta': {
      //     title: '¡Calcule su ahorro!',
      //     meta: [
      //       {'charset': 'utf-8'}
      //     ]
      //   }
      // },
      {
        'path': 'quienes-somos',
        'path_id': 'about-us',
        'html': '/static/info/es/about.html',
        'title': 'Quiénes Somos',
        'header': true,
        'meta': {title: 'Quiénes Somos',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'contact',
        'path_id': 'contact',
        'html': '',
        'title': 'Contacto',
        'header': true,
        'meta': {}
      }
    ]
  },
  'ca-es': {
    'index': {
      'html':
      '<div class="white--text">' +
      '<h2 class="display-3">Rethinking Medical Exchange</h2>' +
      '<p class="headline">Idonia és un servei en el núvol que garanteix <strong>seguretat en l\'accés, comunicació i portabilitat </strong> dels registres mèdics i les imatges, entre els professionals mèdics i el pacient.</p>' +
      '<p>' +
      '<a target="_blank" href="https://twitter.com/IdoniaHealth"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg></a>' +
      '<a target="_blank" href="https://www.facebook.com/IdoniaHealth-307636029699684/"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="white" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg></a>' +
      '<a target="_blank" href="http://www.linkedin.com/company/idonia"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="white" d="M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z"/></svg></a>' +
      '</p>' +
      '</div>',
      'color': '#44A9D5',
      'meta': {title: 'Idonia',
        meta: [
          {'charset': 'utf-8'}
        ]
      }
    },
    'info': [
      {
        'path': 'caracteristicas',
        'path_id': 'features',
        'html': '/static/info/es/features.html',
        'title': 'Característiques',
        'header': true,
        'meta': {title: 'Características',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'soluciones',
        'path_id': 'solutions',
        'html': '/static/info/es/solutions.html',
        'title': 'Solucions',
        'header': true,
        'meta': {title: 'Soluciones',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      // {
      //   'path': 'icd',
      //   'html': 'https://icd.idonia.com',
      //   'title': '¡Calculi el seu estalvi!',
      //   'header': true,
      //   'meta': {
      //     title: '¡Calculi el seu estalvi!',
      //     meta: [
      //       {'charset': 'utf-8'}
      //     ]
      //   }
      // },
      {
        'path': 'quienes-somos',
        'path_id': 'about-us',
        'html': '/static/info/es/about.html',
        'title': 'Sobre nosaltres',
        'header': true,
        'meta': {title: 'Quiénes Somos',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'contact',
        'path_id': 'contact',
        'html': '',
        'contact': true,
        'title': 'Contacte',
        'header': true,
        'meta': { }
      }
    ]
  },
  'en-us': {
    'index': {
      'html':
      '<div class="white--text">' +
      '<h2 class="display-3">Rethinking Medical Exchange</h2>' +
      '<p class="headline">Idonia is a cloud service that guarantees <strong>secure access, communication and portability</strong> of medical records and images, between medical professionals and the patients.</p>' +
      '<p>' +
      '<a target="_blank" href="https://twitter.com/IdoniaHealth"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg></a>' +
      '<a target="_blank" href="https://www.facebook.com/IdoniaHealth-307636029699684/"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="white" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg></a>' +
      '<a target="_blank" href="http://www.linkedin.com/company/idonia"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="white" d="M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z"/></svg></a>' +
      '</p>' +
      '</div>',
      'color': '#44A9D5',
      'meta': {title: 'Idonia',
        meta: [
          {'charset': 'utf-8'}
        ]}
    },
    'info': [
      {
        'path': 'features',
        'path_id': 'features',
        'html': '/static/info/en/features.html',
        'title': 'Features',
        'header': true,
        'meta': {title: 'Features',
          meta: [
            {'charset': 'utf-8'}
          ]}
      },
      {
        'path': 'solutions',
        'path_id': 'solutions',
        'html': '/static/info/en/solutions.html',
        'title': 'Solutions',
        'header': true,
        'meta': {title: 'Solutions',
          meta: [
            {'charset': 'utf-8'}
          ]}
      },
      // {
      //   'path': 'icd',
      //   'html': 'https://icd.idonia.com',
      //   'title': 'Calc your savings!',
      //   'header': true,
      //   'meta': {
      //     title: 'Calc your savings!',
      //     meta: [
      //       {'charset': 'utf-8'}
      //     ]
      //   }
      // },
      {
        'path': 'about-us',
        'path_id': 'about-us',
        'html': '/static/info/en/about.html',
        'title': 'About Us',
        'header': true,
        'meta': {title: 'About Us',
          meta: [
            {'charset': 'utf-8'}
          ]}
      },
      {
        'path': 'contact',
        'path_id': 'contact',
        'html': '',
        'title': 'Contact',
        'header': true,
        'meta': {}
      }
    ]
  },
  'it-it': {
    'index': {
      'html':
        '<div class="white--text">' +
        '<h2 class="display-3">Rethinking Medical Exchange</h2>' +
        '<p class="headline">Idonia è un servizio cloud che garantisce <strong>la sicurezza nell\'accesso, nella comunicazione e nella portabilità</strong> delle cartelle cliniche e delle immagini, tra i professionisti medici e il paziente.</p>' +
        '<p>' +
        '<a target="_blank" href="https://twitter.com/IdoniaHealth"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg></a>' +
        '<a target="_blank" href="https://www.facebook.com/IdoniaHealth-307636029699684/"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="white" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg></a>' +
        '<a target="_blank" href="http://www.linkedin.com/company/idonia"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="white" d="M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z"/></svg></a>' +
        '</p>' +
        '</div>',
      'color': '#44A9D5',
      'meta': {title: 'Idonia',
        meta: [
          {'charset': 'utf-8'}
        ]}
    },
    'info': [
      {
        'path': 'features',
        'path_id': 'features',
        'html': '/static/info/en/features.html',
        'title': 'Caratteristiche',
        'header': true,
        'meta': {title: 'Features',
          meta: [
            {'charset': 'utf-8'}
          ]}
      },
      {
        'path': 'solutions',
        'path_id': 'solutions',
        'html': '/static/info/en/solutions.html',
        'title': 'Soluzioni',
        'header': true,
        'meta': {title: 'Solutions',
          meta: [
            {'charset': 'utf-8'}
          ]}
      },
      // {
      //   'path': 'icd',
      //   'html': 'https://icd.idonia.com',
      //   'title': 'Calc your savings!',
      //   'header': true,
      //   'meta': {
      //     title: 'Calc your savings!',
      //     meta: [
      //       {'charset': 'utf-8'}
      //     ]
      //   }
      // },
      {
        'path': 'about-us',
        'path_id': 'about-us',
        'html': '/static/info/en/about.html',
        'title': 'Chi siamo',
        'header': true,
        'meta': {title: 'About Us',
          meta: [
            {'charset': 'utf-8'}
          ]}
      },
      {
        'path': 'contact',
        'path_id': 'contact',
        'html': '',
        'title': 'Contatto',
        'header': true,
        'meta': {}
      }
    ]
  },
  'eu-es': {
    'index': {
      'html':
        '<div class="white--text">' +
        '<h2 class="display-3">Rethinking Medical Exchange</h2>' +
        '<p class="headline">Idonia hodeiko zerbitzu bat da, profesional medikoen eta pazientearen arteko mediku-erregistro eta irudien <strong>sarbide, komunikazio eta eramangarritasunean segurtasuna</strong> bermatzen duena.</p>' +
        '<p>' +
        '<a target="_blank" href="https://twitter.com/IdoniaHealth"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg></a>' +
        '<a target="_blank" href="https://www.facebook.com/IdoniaHealth-307636029699684/"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="white" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg></a>' +
        '<a target="_blank" href="http://www.linkedin.com/company/idonia"><svg style="width: 36px; height: 36px; margin: 4px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="white" d="M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z"/></svg></a>' +
        '</p>' +
        '</div>',
      'color': '#44A9D5',
      'meta': {title: 'Idonia',
        meta: [
          {'charset': 'utf-8'}
        ]
      }
    },
    'info': [
      {
        'path': 'ezaugarriak',
        'path_id': 'features',
        'html': '/static/info/eu/features.html',
        'title': 'Ezaugarriak',
        'header': true,
        'meta': {title: 'Ezaugarriak',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'soluzioak',
        'path_id': 'solutions',
        'html': '/static/info/eu/solutions.html',
        'title': 'Soluzioak',
        'header': true,
        'meta': {title: 'Soluzioak',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'guri-buruz',
        'path_id': 'about-us',
        'html': '/static/info/eu/about.html',
        'title': 'Guri buruz',
        'header': true,
        'meta': {title: 'Guri buruz',
          meta: [
            {'charset': 'utf-8'}
          ]
        }
      },
      {
        'path': 'contact',
        'path_id': 'contact',
        'html': '',
        'title': 'Harremanetan jarri',
        'header': true,
        'meta': {}
      }
    ]
  }
}

module.exports = info



// WEBPACK FOOTER //
// ./src/marketing.js